export const BOARD_CODE_ROOM_ONLY = 'RO'
export const BOARD_CODE_SELF_CATERING = 'SC'
export const BOARD_CODE_BED_BREAKFAST = 'BB'
export const BOARD_CODE_HALF_BOARD = 'HB'
export const BOARD_CODE_FULL_BOARD = 'FB'
